import izenuAPI from '../services/izenuAPI';

// Track audio goes from the browser straight to S3: the server only signs the
// upload (api/upload/presignSong.php) and S3 enforces the size. Masters in WAV
// or FLAC run past the 40 MB PHP takes in a request. WAV and FLAC are converted
// to MP3 for streaming on the server; the original is kept.
// Same limits and words as the web app (izenu-web-app/src/components/studio/ui.ts).

export const AUDIO_EXTS = ['mp3', 'mpeg', 'mpga', 'wav', 'wave', 'flac'];
// video/mpeg too: macOS files .mpeg as a movie, and the picker greys it out otherwise.
export const AUDIO_ACCEPT = '.mp3,.mpeg,.mpga,.wav,.wave,.flac,audio/mpeg,audio/wav,audio/flac,video/mpeg';
export const AUDIO_MAX_MB = 150;
export const AUDIO_FORMATS_HINT = 'MP3, WAV ou FLAC · até 150 MB por faixa.';
export const AUDIO_QUALITY_HINT = 'Para melhor qualidade, envia o master em WAV ou FLAC (16 ou 24 bits).';

export const audioExt = (name) => (name.split('.').pop() || '').toLowerCase();

/** Why a file cannot be uploaded, or null. */
export function audioFileProblem(file) {
    if (!AUDIO_EXTS.includes(audioExt(file.name))) return `${file.name}: só MP3, MPEG, WAV ou FLAC.`;
    if (file.size > AUDIO_MAX_MB * 1024 * 1024) {
        return `${file.name}: tem ${(file.size / 1024 / 1024).toFixed(1)} MB, o máximo é ${AUDIO_MAX_MB} MB. Exporta em FLAC ou MP3.`;
    }
    return null;
}

/**
 * Uploads the audio and returns the file name to send as `music_file`.
 * artistId: whose folder it goes in — required for a distributor or admin
 * session, ignored for an artist's own.
 */
export async function uploadTrackAudio(file, { artistId, onProgress } = {}) {
    const { data } = await izenuAPI.post('/upload/presignSong.php', {
        file_name: file.name,
        size: file.size,
        artist_id: artistId,
    });
    if (!data?.response || !data.url) throw new Error(data?.message || 'Não foi possível preparar o envio.');

    await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', data.url);
        xhr.upload.onprogress = (e) => { if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100)); };
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) return resolve();
            const code = (/<Code>([^<]+)<\/Code>/.exec(xhr.responseText) || [])[1];
            reject(new Error(code === 'EntityTooLarge'
                ? `O ficheiro passa de ${AUDIO_MAX_MB} MB.`
                : `O envio falhou (${code || xhr.status}). Tenta novamente.`));
        };
        xhr.onerror = () => reject(new Error('A ligação caiu durante o envio. Verifica a internet e tenta novamente.'));
        const fd = new FormData();
        Object.entries(data.fields).forEach(([k, v]) => fd.append(k, v));
        fd.append('file', file); // must be the last field
        xhr.send(fd);
    });

    return data.file_name;
}
